"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTranslations = void 0;
const notebook_1 = require("./notebook");
const admin_1 = require("./admin");
const import_export_1 = require("./import_export");
exports.getTranslations = (custom) => (Object.assign(Object.assign({ notebook: notebook_1.default,
    admin: admin_1.default }, import_export_1.default), custom));
exports.default = exports.getTranslations;
